import type { VtexOrderListItem } from '@/interfaces'

export type CustomerClassification = 'Bronze' | 'Prata' | 'Ouro'
export type MedalType = 'Bronze' | 'Prata' | 'Ouro'

export interface CustomerTier {
  classification: CustomerClassification
  medal: MedalType
  totalSpent: number
}

export function classifyCustomer(orders: VtexOrderListItem[]): CustomerTier {
const sixMonthsAgo = new Date()
sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6)

  const recentOrders = orders.filter(order => {
    const orderDate = new Date(order.creationDate)
    return orderDate >= sixMonthsAgo && order.status !== 'canceled'
  })

  const totalSpent = recentOrders.reduce((sum, order) => {
    return sum + (order.totalValue / 100)
  }, 0)

  let classification: CustomerClassification
  if (totalSpent <= 999.99) {
    classification = 'Bronze'
  } else if (totalSpent <= 1999.99) {
    classification = 'Prata'
  } else {
    classification = 'Ouro'
  }

  const medalMap: Record<CustomerClassification, MedalType> = {
    'Bronze': 'Bronze',
    'Prata': 'Prata',
    'Ouro': 'Ouro',
  }

  return {
    classification,
    medal: medalMap[classification],
    totalSpent
  }
}

export function getMedalEmoji(medal: MedalType): string {
  const emojiMap: Record<MedalType, string> = {
    'Bronze': '🥉',
    'Prata': '🥈',
    'Ouro': '🥇'
  }
  return emojiMap[medal]
}

export const CLASSIFICATION_HIERARCHY: Record<CustomerClassification, number> = {
  'Bronze': 1,
  'Prata': 2,
  'Ouro': 3,
}